import { Observable } from 'rxjs';

import { Injectable } from "@angular/core";
import { Kernantwort } from '../../shared/response/kernantwort.model';
import { OaseListe } from './oaseliste.model';

@Injectable()
export abstract class RestService {
	isRequestRunning: boolean;
	fehler: Kernantwort;
	apiUrlPrefix: string;
	apiUrlListId: string;
	API_LIST;
	API_CREATE;
	API_UPDATE;
	API_DELETE;
	// constructor(authService: AuthService, http: HttpClient, translation: TranslationService, _logger: LoggerService);
	abstract init();
	// liste(page: number, size: number, sort: string, sortdirection: string, search: string): Observable<OaseListe<any>>;
	abstract liste(page: number, size: number, sort: string, sortdirection: string, search: string, extra: string): Observable<OaseListe<any>>;
	abstract speichernAendern(element: any): Observable<any>;
	abstract loeschen(id: number): Observable<any>;
	abstract getApiBaseUrl(): string;
	abstract getApiUrl(): string;
}